import React from "react";
import { t } from "i18next";
import { useSelector } from "react-redux";
import PageHeader from "components/PageHeader";
import FixedFooter from "components/FixedFooter";
import WithMap from "components/Hoc/WithMap";
import { ErrorModal, CustomModal } from "components";
import { useParams } from "react-router-dom";
import { useCustomHistory } from "hooks";

function SelectMapLocation({
  checkoutPageUrl,
  handleConfirmLocation,
  error,
  open,
  setOpen,
  mapref,
  setMapRef,
  screenName,
}) {
  const params = useParams();
  const router = useCustomHistory();
  const { temporarymapAddress, temporaryuserLocation, temporaryzoom } =
    useSelector((state) => state.DeliveryAddressReducer);

  const { DomainType } = useSelector((state) => state.AppReducer);

  const goToCheckoutPage = () => {
    router(
      checkoutPageUrl,
      `/${params?.domainName}${checkoutPageUrl}`,
      DomainType
    );
  };

  return (
    <React.Fragment>
      <div className="flex flex-col min-h-full store-page-popup">
        <PageHeader
          pageHeaderClasses="flex justify-between  border-black-100 px-4 w-full relative"
          title={t("Set Delivery Location")}
          page="selectMap"
          url={true}
          handleClick={goToCheckoutPage}
        />
        <p className="text-14x text-gunsmoke leading-19x mb-2 mx-6">
          {t("Mark the exact location to help our driver deliver faster")}
        </p>
        <div className="bg-gray-100 relative " style={{ flex: 1 }}>
          <div className="relative min-h-full" style={{ flex: 1 }}>
            <WithMap
              class="map-height"
              screenName={screenName}
              width="100%"
              height="100%"
              showInput={true}
              zoomChanging={true}
              setMapRef={setMapRef}
              mapref={mapref}
              googlemapState={{
                userLocation: {
                  lat: temporaryuserLocation?.coordinates?.lat,
                  lng: temporaryuserLocation?.coordinates?.lng,
                },
                zoom: temporaryzoom,
                mapAddress: temporarymapAddress,
              }}
              zoomerror={null}
              isZoomModalOpen={false}
              setZoomErrorModal={() => {}}
            />
          </div>

          <FixedFooter
            page={false}
            from="selec location"
            screen="confirmLocation"
          >
            <span className="block w-full">
              <button
                onClick={handleConfirmLocation}
                className="block text-center py-4 rounded text-brand-text-primary bg-brand-base-primary cursor-pointer text-16x w-full"
              >
                <span className="">
                  <div className="">
                    <span className="font-bold">{t("Confirm Location")}</span>
                  </div>
                </span>
              </button>
            </span>
            <CustomModal
              open={open}
              setOpen={setOpen}
              bodyclasses="flex"
              overlayClasses="  fixed h-screen w-screen top-0 bg-opacity-50 overflow-hidden transition ease-linear duration-700 z-40"
            >
              <ErrorModal setOpen={setOpen} message={error} />
            </CustomModal>
          </FixedFooter>
        </div>
      </div>
    </React.Fragment>
  );
}

export default SelectMapLocation;
